import './pages/persona/index.js';
import './pages/contratos.js';
import './pages/usuarios.js';
import './pages/liquidaciones.js';
import './pages/adhesiones.js';

import { iniciarMenuUsuario } from './modules/userMenu.js';

document.addEventListener('DOMContentLoaded', function () {
    iniciarMenuUsuario();
});